import { datadogRum } from "@datadog/browser-rum";

import type { SideMenuOptOutReasonKey } from "./side-menu-document";

/**
 * ENG-2535 adoption telemetry, the single writer of these action names (the same
 * arrangement as `scheduler-choice-telemetry.ts`). Who and which practice come from
 * RUM's global context. Every field is one of a fixed handful of values; the free-text
 * detail is never sent here, it is stored in the person's document and the backend
 * records it as feature feedback.
 */
export const SIDE_MENU_OPT_IN_ACTION = "side_menu_opt_in";
export const SIDE_MENU_OPT_OUT_ACTION = "side_menu_opt_out";

/** "classic_rail" is the "Try the new menu" button on the old rail. */
export type SideMenuSwitchSource = "classic_rail" | "footer" | "account_menu";

const track = (name: string, context: Record<string, string>) => {
  try {
    datadogRum.addAction(name, context);
  } catch {
    // Telemetry must never break switching menus.
  }
};

export const trackSideMenuOptIn = (source: SideMenuSwitchSource) =>
  track(SIDE_MENU_OPT_IN_ACTION, { source });

export const trackSideMenuOptOut = (
  source: SideMenuSwitchSource,
  reason: SideMenuOptOutReasonKey
) => track(SIDE_MENU_OPT_OUT_ACTION, { source, reason });
